import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import Layout from './components/Layout';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import Sabotage from './components/Sabotage';
import NotFound from './components/NotFound';

function App() {
  useEffect(() => {
    AOS.init({
      offset: 300,
      duration: 2000,
    });
  }, []);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Home />} />
        <Route path="/games" element={<Home />} />
        <Route path="/team" element={<Home />} />
        <Route path="/contact" element={<Home />} />
        <Route path="/mgg-privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/sabotage" element={<Sabotage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default App;